import React from 'react';


import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import { Carousel } from 'react-responsive-carousel';



import Header from './Header';
import Footer from './Footer';
import Banner from './Banner';
import Feature from './Features';
import Screens from './Screens';
import Solutions from './Solutions';
import Faq from './faq';
import FooterBanner from './FooterBanner';
import WomanBanner from './WomanBanner';


function Home() {
return (
<React.StrictMode>
   <Header/>
   <Banner/>
   <Feature/>
  
  
      <Screens/>

   <Solutions/>
   <WomanBanner/>
   <Faq/>
   <FooterBanner/>
    <Footer/>
</React.StrictMode>
)
}
export default Home;